import React, { Component } from "react";
import throttle from "lodash/throttle";

import styles from "../../styles";
import { Div } from "glamorous";

class ScrollFixedContainer extends Component {
  constructor(props) {
    super(props);
    this.state = {
      progressFixed: false,
      paddingTop: 0
    };
  }

  componentDidMount() {
    this.setState({ sticky: this.el.offsetTop });

    this.throttledScroll = throttle(this.handleScroll, 200);
    window.addEventListener("scroll", this.throttledScroll);

    this.handleScroll();
  }

  componentWillUnmount() {
    window.removeEventListener("scroll", this.throttledScroll);
  }

  handleScroll = () => {
    if (!this.state.sticky || !this.el) {
      return;
    }
    
    const headerHeight = 51;
    const gutter = 10;
    const paddingTop = this.el.clientHeight + gutter;

    if ((window.pageYOffset) > (headerHeight + gutter)) {
      this.setState({
        progressFixed: true,
        paddingTop: paddingTop
      });
    } else {        
      this.setState({
        progressFixed: false,
        paddingTop: 0
      });
    }
  }

  render() {
    return (
      <Div css={styles.editor.leftCol}>
        <Div css={this.state.progressFixed ? styles.editor.fixedContainer : null}
          innerRef={el => (this.el = el)}>
          <Div>
            { this.props.children }
          </Div>
        </Div>
        <Div css={styles.editor.fixedContainerGutter} paddingTop={ this.state.paddingTop } />
      </Div>
    );
  }
}
  
export default ScrollFixedContainer;



// WEBPACK FOOTER //
// ./src/components/common/ScrollFixedContainer.js